import React, { Component } from "react";
import { connect } from "react-redux";
import { onLocationSelect } from "./stepHelpers";
import { TextButton, StepItem } from "../Shared";
import { locationSelector } from "../../selectors";
import {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep,
  updateLocationPosition
} from "../../actions";
import * as STEP_KEYS from "../../consts/stepKeys";

class LocationSelect extends Component {
  componentDidMount = () => {
    if (this.props.value !== "" && this.props.current) {
      this.handleSelect(this.props);
    }
  };

  componentWillReceiveProps = nextProps => {
    if (!nextProps.required && this.props.current) {
      this.handleSelect(nextProps);
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      this.props.value === nextProps.value &&
      this.props.current === nextProps.current
    ) {
      return false;
    }
    return true;
  };

  handleSelect = props => {
    const location = props.options.find(f => f.locationId === props.value);

    onLocationSelect(props, location);
  };

  render() {
    return (
      <StepItem>
        {this.props.hintText}
        <TextButton
          placeholder="[select location]"
          value={this.props.text}
          onClick={() => this.props.toggleControl(STEP_KEYS.LOCATION, true)}
          reload={this.props.reload}
        />
      </StepItem>
    );
  }
}

export default connect(locationSelector, {
  updateAppointmentDetail,
  toggleControl,
  goToStep,
  goBackToStep,
  completeStep,
  updateLocationPosition
})(LocationSelect);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/LocationSelect.js